"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16HomeLine = function Svg16HomeLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.772 19c-.111 0-.294 0-.463-.014a2.504 2.504 0 0 1-.944-.259 2.5 2.5 0 0 1-1.093-1.092 2.505 2.505 0 0 1-.259-.944C6 16.522 6 16.34 6 16.228V12.91a2.358 2.358 0 0 1-1.156-.592 2.5 2.5 0 0 1-.737-2.3c.094-.476.321-.818.48-1.017.16-.2.332-.355.455-.46.223-.189.514-.396.779-.585l4.552-3.251.01-.009c.078-.059.495-.376 1.003-.505a2.5 2.5 0 0 1 1.228 0c.508.129.925.446 1.002.505l.011.009 4.552 3.25c.265.19.556.397.779.586.123.105.295.26.455.46.159.199.386.54.48 1.017a2.5 2.5 0 0 1-.738 2.3A2.358 2.358 0 0 1 18 12.91v3.318c0 .111 0 .294-.014.463a2.504 2.504 0 0 1-.259.944 2.5 2.5 0 0 1-1.092 1.092 2.504 2.504 0 0 1-.944.26c-.169.013-.352.013-.463.013H8.772zm3.35-12.87c.092.023.176.083.343.202l4.504 3.217c.615.44.923.66.961.854a.5.5 0 0 1-.147.46c-.145.137-.523.137-1.28.137H16v5.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C15.62 17 15.48 17 15.2 17H14v-3a2 2 0 1 0-4 0v3H8.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C8 16.62 8 16.48 8 16.2V11h-.504c-.756 0-1.134 0-1.279-.136a.5.5 0 0 1-.147-.46c.038-.195.346-.415.961-.855l4.504-3.217c.167-.12.251-.18.342-.202a.5.5 0 0 1 .246 0z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16HomeLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16HomeLine;
exports.default = _default;